<h2>Quadro Regionale degli Standard Professionali della Lombardia</h2>
<p>Benvenuti nel sito del Quadro Regionale degli Standard Professionali (QRSP) della Regione
  Lombardia.<br />
  Il Quadro Regionale degli Standard Professionali (QRSP) definisce e classifica l'insieme dei
  profili professionali, declinati in competenze, caratteristici ed attivi nel mondo del
  lavoro
  lombardo.<br />
  Il Quadro Regionale di standard professionali, costruito secondo regole coerenti con i
  modelli
  europei e nazionali, rappresenta il riferimento univoco per la progettazione e la
  realizzazione
  dei percorsi di formazione continua, permanente e di specializzazione nonchè per la
  certificazione delle competenze acquisite in qualsiasi ambito, che possano avere un
  riconoscimento 'pubblico'.</p>

<p>Sviluppo del QRSP in relazione ai lavori istituzionali sul Repertorio Nazionale
  il Quadro Regionale di Standard Professionali (QRSP) è il Repertorio regionale delle
  qualificazioni professionali, in coerenza con il Repertorio nazionale/Quadro nazionale, di
  cui
  al decreto interministeriale del 30 giugno 2015, nonchè con il Sistema Nazionale di
  certificazione delle competenze, di cui al d.lgs. 16 gennaio 2013, n. 13.</p>

<p>Il Repertorio è il risultato di un complesso lavoro, portato avanti con i componenti della
  Sottocommissione CRPLF per l'aggiornamento del QRSP, che nel corso degli anni hanno
  condiviso le
  innovazioni e validato tutta la documentazione tecnica, contribuendo a rendere gli standard
  ed i
  profili sempre più aderenti alle richieste del mercato del lavoro lombardo.</p>

<p>Il QRSP è articolato nei 24 Settori Economico-Professionali previsti dal Repertorio
  nazionale; è
  diviso nelle seguenti sezioni</p>

<p>Sezione Profili professionali e Competenze indipendenti</p>
<ul>
  <li>Sezione Competenze di base</li>
  <li>Sezione Competenze trasversali</li>
  <li>Sezione competenze bionaturali</li>
  <li>Sezione figure regolamentate/abilitanti</li>
  <li>Sezione percorsi regolamentati</li>
</ul>

<p>Tutti i decreti di approvazione dei successivi aggiornamenti del QRSP sono reperibili nella
  sezione "decreti di approvazione".</p>

<p>Il QRSP è correlato all'Atlante del Lavoro e delle Qualificazioni dispositivo informativo
  realizzato sulla base delle sequenze descrittive della Classificazione dei settori
  economico-professionali e dei livelli del Quadro Nazionale delle Qualificazioni, che
  organizza
  le qualificazioni regionali e le relative competenze nel rispetto degli standard minimi
  stabiliti ai sensi dell’articolo 8 del decreto legislativo n. 13 del 2013 e dell’articolo 3,
  comma 5, del decreto interministeriale del 30 giugno 2015. L'Atlante è disponibile sul sito
  <a href="https://atlantelavoro.inapp.org/" target="_blank">https://atlantelavoro.inapp.org/</a> dove è possibile tra
  l'altro
  visualizzare simultaneamente tutte
  le qualificazioni contenute nei vari repertori regionali e correlate con le Aree di Attività
  Nazionali.
</p>

<p>
  <a href="http://www.gazzettaufficiale.it/eli/id/2015/07/20/15A05469/sg" target="_blank">Gazzetta Ufficiale</a>
</p>

<p>
  <a href="https://atlantelavoro.inapp.org/" target="_blank"> Atlante del Lavoro e delle
    Qualificazioni </a>
</p>

<div class="example-container mat-elevation-z8">
  <div class="example-table-container">
    <table mat-table [dataSource]="dataSource" class="example-table" matSort matSortActive="descrizione" matSortDisableClear matSortDirection="asc">
      <ng-container matColumnDef="descrizione">
        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>
          Descrizione
        </th>
        <td mat-cell *matCellDef="let element"> {{element.descrizione}} </td>
      </ng-container>
      <ng-container matColumnDef="azioni">
        <th mat-header-cell *matHeaderCellDef>
          Azioni
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-icon class="green" (click)="downloadAllegato(element)" matTooltip="Download Allegato">
            download</mat-icon>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="height:24px !important;"></tr>
    </table>
  </div>
  <mat-paginator #paginator [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" [length]="totalItems"
    [pageIndex]="pageIndex" (page)="onPaginateChange($event)" showFirstLastButtons></mat-paginator>
</div>
